export const getAlternativePostPath = (post: {
  categories?: {
    nodes?: ({ slug?: string | null } | null | undefined)[] | null;
  } | null;
}) =>
  post.categories?.nodes?.find(
    (category) => decodeURIComponent(category?.slug || '') === 'interview'
  )
    ? 'interview'
    : undefined;
